import { SET_WEBSITE_PASSWORD_VALIDITY } from '../actionTypes';
export default function reducer(state = {}, action) {
  if (action.type === SET_WEBSITE_PASSWORD_VALIDITY) {
    return {
      ...state,
      isValidPassword: action.payload
    };
  }
  return state;
}
